import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './Hero.css';
import messages from '../../../../locale/messages';

function Hero({ intl }) {
  useStyles(s);

  return (
    <section id="home" className={s.hero}>
      <div className={s.inner}>
        <div className={s.left}>
          <p className={s.eyebrow}>ASAP SUPER DELIVERY</p>
          <h1 className={s.title}>
            <FormattedMessage {...messages.homeHeroTitle} />
          </h1>
          <p className={s.subtitle}>
            <FormattedMessage {...messages.homeHeroSubtitle} />
          </p>

          <div className={s.actions}>
            <a href="https://linktr.ee/DOWNLOADASAP" className={s.btnPrimary}>
              <FormattedMessage {...messages.homeOrderNow} />
            </a>
            <a href="/store/signup" className={s.howTo}>
              <FormattedMessage {...messages.homeBecomePartner} />
              <span className={s.playIcon}>🤝</span>
            </a>
          </div>

          {/* <div className={s.happy}>
            <div>
              <p className={s.happyLabel}>Our Happy Customer</p>
              <div className={s.avatars}>
                <img src="https://picsum.photos/seed/cust1/80/80" alt="" />
                <img src="https://picsum.photos/seed/cust2/80/80" alt="" />
                <img src="https://picsum.photos/seed/cust3/80/80" alt="" />
              </div>
            </div>
            <p className={s.rating}>
              <b>4.8</b> 12 Review
            </p>
          </div> */}
        </div>

        <div className={s.right}>
          {/* <div className={s.floatTopLeft}>🍔</div>
          <div className={s.floatTopRight}>🍕</div> */}
<img
            src="/SiteImages/hero.webp"
            alt={intl.formatMessage(messages.homeHeroImageAlt)}
          />
          <div className={s.fastDelivery}>
            <span className={s.fastDeliveryIcon}>⚡</span>
            <div>
              <p className={s.fastDeliveryTitle}>
                <FormattedMessage {...messages.homeFastDelivery} />
              </p>
              <p className={s.fastDeliverySubtitle}>
                <FormattedMessage {...messages.homeFastDeliverySubtitle} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default injectIntl(Hero);
